import { httpGet, httpPost, httpPut, httpDelete, httpGet_New } from './api.service';
import { GetSettingRequest } from '../requestModels/getSettingRequest';
import { Setting } from '../types/Settings';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { DeviceSettings } from '../types/DeviceTypeSettings';

export const getAllSettings = async (request: GetSettingRequest): Promise<Setting> => {
  return await httpGet<Setting>(`api/setting`, request);
};

export const getAllSettingsByScope = async (scopeName: string): Promise<Setting[]> => {
  return await httpGet_New<Setting[]>(`api/setting/scope/${scopeName}`);
};

export const getCustomerTypes = async (): Promise<Setting> => {
  return await httpGet_New<Setting>(`api/setting/CustomerTypes`);
};

export const getTerms = async (): Promise<Setting> => {
  return await httpGet_New<Setting>(`api/setting/Terms`);
};

export const getAllDeviceTypes = async (request: PaginatedRequest): Promise<PaginatedResult<any>> => {
  return await httpGet<PaginatedResult<any>>(`api/device-type`, request);
};

export const updateDeviceTypeSettings = async (deviceTypeId: string | undefined, request: DeviceSettings) => {
  return await httpPost(`api/device-type/${deviceTypeId}`, request);
};

export const addSetting = async (request: Setting): Promise<boolean> => {
  return await httpPost(`api/setting`, request);
};

export const updateSetting = async (request: Setting): Promise<boolean> => {
  return await httpPut(`api/setting/${request.id}`, request);
};

export const deleteSetting = async (id: string): Promise<boolean> => {
  return await httpDelete(`api/setting/${id}`);
};

export const getOverridableSettings = async (): Promise<Setting[]> => {
  return await httpGet_New<Setting[]>(`api/setting/overridable`);
};

export const getCompanySettingOverrides = async (companyId: string): Promise<Setting[]> => {
  return await httpGet_New<Setting[]>(`api/setting/company/${companyId}`);
};

export const upsertCompanySettingOverride = async (companyId: string, request: Omit<Setting, 'id'>): Promise<Setting> => {
  return await httpPut(`api/setting/company/${companyId}`, request);
};

export const deleteCompanySettingOverride = async (companyId: string, settingId: string): Promise<boolean> => {
  return await httpDelete(`api/setting/company/${companyId}/${settingId}`);
};
